import { haptic } from '@/lib/telegram';
import type { ContentItem } from '@/types/content';
import { contentTypeEmojis, contentTypeLabels } from '@/types/content';

// SPEC-021: Feed tile. Mirrors AssignmentRow's shape so the Learning Hub
// feels native to the rest of the mini app.

interface ContentCardProps {
  item: ContentItem;
  onClick: () => void;
}

export function ContentCard({ item, onClick }: ContentCardProps) {
  return (
    <button
      type="button"
      onClick={() => {
        haptic('selection');
        onClick();
      }}
      className="flex w-full flex-col gap-1 rounded-xl bg-[var(--color-secondary-bg)] px-4 py-3 text-left transition-opacity active:opacity-80"
    >
      <div className="flex items-center justify-between gap-2">
        <span className="line-clamp-1 text-base font-medium">{item.title}</span>
        <span className="shrink-0 text-lg leading-none">
          {contentTypeEmojis[item.content_type]}
        </span>
      </div>
      {item.summary && (
        <p className="line-clamp-2 text-xs leading-snug text-[var(--color-muted)]">
          {item.summary}
        </p>
      )}
      <div className="flex items-center gap-2 pt-1 text-[10px] uppercase tracking-wide text-[var(--color-muted)]">
        <span>{contentTypeLabels[item.content_type]}</span>
        {typeof item.estimated_minutes === 'number' && item.estimated_minutes > 0 && (
          <>
            <span>·</span>
            <span>{item.estimated_minutes} min</span>
          </>
        )}
      </div>
    </button>
  );
}
